export const Status = {
    NONE: 0,
    EDIT: 1,
    SEND: 2,
};

export const MIN_WIDTH_SHOW_CANCEL = 660;

export const BREAKPOINTS_CANCEL = {
    0: {
        slidesPerView: 1,
    },
    950: {
        slidesPerView: 2,
    },
    1350: {
        slidesPerView: 3,
    },
};

export const BREAKPOINTS = {
    0: {
        slidesPerView: 1,
    },
    800: {
        slidesPerView: 2,
    },
    1050: {
        slidesPerView: 3,
    },
};
